import { trigger, animate, transition, style, state } from '@angular/animations';

export const GalleryAnimation = trigger('GalleryAnimation', [
  state('noAnimation', style({ opacity: 1 })), // No animation state
  state('fadeIn', style({ opacity: 1 })), // Fade in state
  state('fadeOut', style({ opacity: 0 })), // Fade out state

  // Transition definitions
  transition('* => noAnimation', animate('0ms')), // Transition to noAnimation with no animation
  transition('* => fadeIn', animate('1000ms ease-in')), // Transition to fadeIn with fade in animation
  transition('* => fadeOut', animate('1000ms ease-out')), // Transition to fadeOut with fade out animation
]);
